import { render } from "./DictionaryPlaceDetail.vue?vue&type=template&id=cc446e6e"
import script from "./DictionaryPlaceDetail.vue?vue&type=script&lang=js"
export * from "./DictionaryPlaceDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__